import React from "react";

function Header(){
  const HeaderStyles = {
    textAlign: "Center",
    marginBottom: "2em"
  };
  return(
    <h1 style={HeaderStyles}>Tap Room</h1>
  );
}

export default Header;